function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React, { forwardRef, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { ProfileHeadDiv } from './Components';
import DownloadsMenu from './DownloadsMenu';
import { IconButton } from '../buttons';
import { Block, FlexRow, LargeText } from '../content';
import { Form } from '../forms';
import { FiltersIcon } from '../icons';
const ContainerHeaderCustom = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    t
  } = useTranslation();
  const {
    entity,
    title,
    toolbarActionsContent,
    onChange,
    onSubmit,
    titleAndToolbars = false,
    onlyTitle = false,
    onlyToolbars = false,
    noHeader = false,
    titleAndFilters = false,
    children,
    showDownloadTool,
    showAiTool,
    onAiClick,
    searchFieldName = 'search',
    extraButton = null,
    paidPackage
  } = props;
  if (noHeader) {
    return null;
  }
  if (onlyToolbars) {
    return /*#__PURE__*/React.createElement(ProfileHeadDiv, null, /*#__PURE__*/React.createElement("div", null, toolbarActionsContent));
  }
  if (onlyTitle) {
    return /*#__PURE__*/React.createElement(FlexRow, {
      xs: 12,
      padding: 4
    }, /*#__PURE__*/React.createElement(LargeText, null, title || t("".concat(entity, ".titlePlural"))));
  }
  const formProps = {
    onChange,
    onSubmit
  };
  if (titleAndFilters) {
    return /*#__PURE__*/React.createElement(Form, formProps, /*#__PURE__*/React.createElement(LargeText, null, title || t("".concat(entity, ".titlePlural"))), /*#__PURE__*/React.createElement(FlexRow, null, children));
  }
  const _children = React.Children.toArray(children);
  const searchField = _children.find(x => {
    var _x$props;
    return ((_x$props = x.props) === null || _x$props === void 0 ? void 0 : _x$props.name) === searchFieldName;
  });
  const fields = _children.filter(x => {
    var _x$props2;
    return ((_x$props2 = x.props) === null || _x$props2 === void 0 ? void 0 : _x$props2.name) !== searchFieldName;
  });
  let content = null;
  if (!titleAndToolbars) {
    content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FlexRow, {
      justifyContent: fields > 1 && "space-around",
      alignItems: "baseline"
    }, fields.map((x, i) => /*#__PURE__*/React.createElement(Fragment, {
      key: x.props.name || i
    }, x)), formProps.onSubmit && /*#__PURE__*/React.createElement(IconButton, {
      type: "submit",
      tooltip: t('GENERAL.applyFilters'),
      icon: FiltersIcon
    }), extraButton && extraButton, showDownloadTool && /*#__PURE__*/React.createElement(DownloadsMenu, {
      ref: ref,
      extraButton: extraButton,
      paidPackage: paidPackage
    }), showAiTool && /*#__PURE__*/React.createElement(IconButton, {
      tooltip: "AI Chat",
      onClick: onAiClick
    }, "AI")));
  }
  const showSearchField = !!searchField;
  return /*#__PURE__*/React.createElement(Form, _extends({}, formProps, {
    actions: false,
    enableDebounce: true
  }), (title || entity || titleAndToolbars || showSearchField || toolbarActionsContent) && /*#__PURE__*/React.createElement(FlexRow, {
    alignItems: "center",
    paddingRight: 4,
    paddingLeft: 4
  }, (title || entity) && /*#__PURE__*/React.createElement(LargeText, {
    width: "auto",
    textAlign: "left",
    margin: 0,
    marginTop: 4
  }, title || t("".concat(entity, ".titlePlural"))), (titleAndToolbars || showSearchField) && /*#__PURE__*/React.createElement(Block, {
    width: "28%",
    marginBottom: 0,
    marginTop: 0,
    marginLeft: "auto",
    key: "search"
  }, searchField), toolbarActionsContent && /*#__PURE__*/React.createElement(Block, {
    width: "auto",
    marginLeft: !showSearchField && 'auto',
    margin: 0,
    marginTop: 4
  }, toolbarActionsContent)), content);
});
ContainerHeaderCustom.propTypes = {
  entity: PropTypes.string,
  filtersContent: PropTypes.any,
  toolbarActionsContent: PropTypes.any,
  onFilterFormChange: PropTypes.func,
  onAiClick: PropTypes.func
};
const ContainerHeader = /*#__PURE__*/React.memo(ContainerHeaderCustom);
export default ContainerHeader;